const STORAGE_KEY = 'klicker_klacker_best_score';

/**
 * Save best score to localStorage
 */
export function saveBestScore(score: number): void {
  try {
    localStorage.setItem(STORAGE_KEY, score.toString());
  } catch (error) {
    console.warn('Failed to save best score:', error);
  }
}

/**
 * Load best score from localStorage
 */
export function loadBestScore(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const score = parseInt(stored, 10);
      return isNaN(score) ? 0 : score;
    }
  } catch (error) {
    console.warn('Failed to load best score:', error);
  }
  return 0;
}

/**
 * Clear saved data
 */
export function clearStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear storage:', error);
  }
}
